<template>
  <div
    class="container nav-menu"
    :style="mobile ? 'background-color: rgba(255, 255, 255, 0.95); padding-top: 100px' : 'padding-top: 80px;'"
    @click="toggleClosed">
    <ul class="primary-nav-menu">
      <li class="nav-menu-item">
        <router-link :to="{ name: 'home' }">Home</router-link>
      </li>
      <li class="nav-menu-item">
        <router-link :to="{ name: 'about' }">About</router-link>
      </li>
      <!-- <li class="nav-menu-item">
        <router-link :to="{ name: 'calculator' }">Forecasting Simulator</router-link>
      </li> -->
      <li class="nav-menu-item">
        <router-link :to="{ name: 'methodology' }">Methodology</router-link>
      </li>
      <li class="nav-menu-item">
        <a href="https://decisiondeskhq.com/">DDHQ Blog</a>
      </li>
      <li class="nav-menu-item">
        <a href="https://results.decisiondeskhq.com/">Results</a>
      </li>
      <li :key="$auth.authenticated" class="nav-menu-item" v-if="!$auth.authenticated">
        <router-link :to="{ name: 'login' }">Login</router-link>
      </li>
      <li :key="$auth.authenticated" class="nav-menu-item" v-else>
        <a href="/" @click="logout($event)">Logout</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

const computed = {
  ...mapGetters({
    mobile: 'ux/mobile'
  })
}

const methods = {
  ...mapActions({
    toggleClosed: 'ux/toggleClosed'
  }),
  logout ($event) {
    $event.preventDefault()
    this.$auth.logout()
    if ((this.$route.meta || {}).auth === true) {
      this.$router.push('/')
    }
  }
}

export default {
  computed,
  methods
}
</script>

<style>
.nav-menu {
  position: fixed;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  z-index: 1001;
  overflow: auto;
  /* background-color: rgba(250, 250, 250, 0.6) !important; */
}

.nav-menu-item {
  font-size: 1.4em;
  font-weight: 400;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.nav-menu-item a {
  color: #333;
}

.nav-menu-item .router-link-exact-active {
  color: #FA3138 !important;
}

.primary-nav-menu, .secondary-nav-menu {
  list-style-type: none;
}

.active-nav-menu-item {
  color: #FA3138 !important;
}

@media only screen and (max-width: 960px) {
  .nav-menu {
    background-color: #FAFAFA;
  }
}

@media only screen and (min-width: 421px) {
  .nav-menu-item {
    text-align: end;
  }

  .nav-menu-item a {
    padding: 5px 8px;
    background: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  }
}

@media only screen and (max-width: 420px) {
  .nav-menu {
    z-index: 1002;
  }

  .nav-menu-item {
    font-size: 1.2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/NavMenu.vue